import _ from 'lodash';
export const floorTwoDecimal = (value) => {
    if (typeof value === 'string') {
        return _.floor(Number(value), 2);
    }
    return _.floor(value, 2);
};
